// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import NewProductButton from '../../common/new-product-button/NewProductButtonComponent';
import { getProductTypeIds, getProductTypeIntlPluralKey } from '../../services/product-type/ProductTypeService';
import { getProductRouteById, defaultProductRoute } from '../../services/products-route/ProductsRouteService';
import type { ProductSizes } from '../../../api/types/ProductSizes';
import productsMessages from '../../../data/products';

import NavBar from '../../common/nav-bar/NavBarComponent';

import './ProductTypeSelect.scss';

type Props = {
  productTypeId: string,
  config: {
    permissions: Array<string>,
    productSizesAvailable: Array<ProductSizes>,
  },
  actions: {
    saveParentLocationAction: () => void,
  },
};

class ProductTypeSelectComponent extends React.Component<Props> {
  static displayName = 'ProductTypeSelect';

  static propTypes = {
    productTypeId: PropTypes.string,
    config: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      saveParentLocationAction: PropTypes.func.isRequired,
    }),
  };

  static contextTypes = {
    intl: intlShape.isRequired,
  };

  UNSAFE_componentWillMount(): void {
    this.props.actions.saveParentLocationAction(window.location.pathname);
  }

  shouldComponentUpdate(nextProps: Props): boolean {
    return (
      nextProps.productTypeId !== this.props.productTypeId ||
      nextProps.config.permissions !== this.props.config.permissions ||
      nextProps.config.productSizesAvailable !== this.props.config.productSizesAvailable
    );
  }

  render(): Element {
    const navBarItems = [defaultProductRoute, ...getProductTypeIds()].map((id: string) => {
      const value = getProductRouteById(id);
      return {
        value,
        label: this.context.intl.formatMessage(getProductTypeIntlPluralKey(id)),
      };
    });

    return (
      <div className="product-type-select-component">
        <div className="product-type-select-component__container">
          <div className="product-type-select-component__tabs">
            <NavBar
              items={navBarItems}
              activeRoute={getProductRouteById(this.props.productTypeId)}
              page="products"
              message={this.context.intl.formatMessage(productsMessages.selectProductDropdownLabel)}
            />
          </div>
          {/* Set up new product button - only available on desktop */}
          <NewProductButton config={this.props.config} actions={this.props.actions} />
        </div>
      </div>
    );
  }
}

export default ProductTypeSelectComponent;
